import React, { createRef, useEffect, useState } from "react";
import CustomSearchBar from "../../../components/CustomSearchBar/CustomSearchBar";
import apiUtil from "../../../api/apiUtil";
import Table from "../../../components/Table/Table";
import getToken from "../../getToken";
import api from "../../../api/api";
import "./addPoint.css";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import calenderIcon from "../../../images/icons/calendar.png";
import * as XLSX from 'xlsx';
import excelIcon from "../../../images/icons/download.png";

const AddPoint = () => {
  const refAddTable = createRef();
  const [keyword, setKeyword] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  const [addList, setAddList] = useState({
    isLoading: true,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  let brandId = localStorage.getItem("brandId");
  let branchId = "8cd5fe32-a30a-11ed-b26e-6045bdd63acb";
  const [paramReport, setParamReport] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
    branchId: branchId,
    startDate: format(startDate, "yyyy-MM-dd"),
    endDate: format(endDate, "yyyy-MM-dd"),
  });
  const mapDataRows = (data, value) => {
    return data && data.length > 0
      ? data.map((row, index) => ({
        ...row,
        tableNum: (value.currentPage - 1) * value.rowLimit + index + 1,
        id: `${row.id}-${index}` // override to ensure uniqueness
      }))
      : [];
  };
  const retrieveaddList = async (value = paramReport) => {
    value.keyword = keyword || "";
    value.startDate = format(startDate, "yyyy-MM-dd");
    value.endDate = format(endDate, "yyyy-MM-dd");

    console.log(value);

    api.post("Admin/GetAddPointHistoryReport", value, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          const data = response.data.data;
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            setAddList({
              isLoading: false,
              limit: data.rowLimit,
              data: mapDataRows(data.data, value),
              total: data.totalRecords,
              page: data.paging,
            });
            console.log(data.data);
          } else {
            setAddList({
              data: [],
              total: 0,
              page: 0,
              limit: 0,
              isLoading: false,
            });
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });
  };

  useEffect(() => {
    retrieveaddList();
  }, [paramReport, startDate, endDate]);
  console.log(addList);

  const handleDateRangeChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setStartDate(startDate);
    setEndDate(endDate);
    setDateRange({ startDate, endDate });
    retrieveaddList();
  };

  const handleInputClick = () => {
    setShowDatePicker((prevState) => !prevState);
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".date-input-container")) {
        setShowDatePicker(false);
      }
    };
    console.log("clicked handleOutside")
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const fetchAllData = async () => {
    const allData = [];
    let currentPage = 1;

    try {
      while (true) {
        const response = await api.post(

          "Admin/GetAddPointHistoryReport",
          { ...paramReport, currentPage },
          getToken()
        );
        const { data } = response.data.data.data;
        if (response.data && data && data.length > 0) {
          allData.push(...data);
          currentPage++;
        } else {
          break;
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    console.log("Fetched all data:", allData);
    return allData;
  };


  const exportToExcel = async () => {
    try {
      const allData = await fetchAllData();


      if (allData.length === 0) {
        console.warn("No data to export");
        return;
      }
      const excelDataFormatted = allData.map((row, index) => ({
        No: index + 1,
        Date: row.reportDate ? new Date(row.reportDate).toLocaleDateString("en-US") : "-",
        Time: row.reportTime ? new Date(row.reportTime).toLocaleTimeString("en-US", { hour12: true }) : "-",
        "User Id": row.memberCode || "-",
        Name: row.name || "Unknown",
        "Use Type": row.reportType || "Unknown",
        "Created By": row.createdBy || "-",
        "Deposit": row.addPoint || "-",
        "Expired Point": row.expiredPoint || "-",
        "Usage Point": row.point || "-",
        "Available Point": row.currentPoint || "-",
      }));

      console.log("Excel Data Formatted:", excelDataFormatted);

      const fileName = "PointAddReport.xlsx";

      const ws = XLSX.utils.json_to_sheet(excelDataFormatted);
      // console.log("Worksheet:", ws);
      ws['!cols'] = [
        { wpx: 30 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 }
      ];
      ws['!cols'].forEach(col => {
        col.s = { alignment: { horizontal: 'left' } };
      });

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "PointAddReport");

      // console.log("Workbook:", wb);
      XLSX.writeFile(wb, fileName);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    }
  };

  return (
    <>
      <div className="Actions space_between">
        <h6 className="title_text mt-2">Point Add History</h6>

        <div className="d-flex justify-content-end gap-16 align-items-center">
          <div>
            <button onClick={exportToExcel} className="export-button">
              <img src={excelIcon} alt="excelIcon" className="icon" /> Export to Excel
            </button>
          </div>
          {/* dateRangePicker */}
          <div className="date-input-container ">
            <input
              type="text"
              className="inputBox input-right-side_text "
              value={`${format(dateRange.startDate, "yyyy MMM dd")} - ${format(
                dateRange.endDate,
                "yyyy MMM dd"
              )}`}
              readOnly
              onClick={handleInputClick}
            />
            <button onClick={handleInputClick} className="iconButton" >
              <img src={calenderIcon} alt="caleanderIcon" className="iconDate" />
            </button>

            {showDatePicker && (
              <div className="input-dateRange">
                <DateRange
                  showDateDisplay={false}
                  ranges={[{ startDate, endDate, key: "selection" }]}
                  onChange={handleDateRangeChange}
                />
              </div>
            )}
          </div>
          <div>
            <CustomSearchBar value={keyword} setValue={setKeyword} onSearch={() => retrieveaddList()} />
          </div>

        </div>
      </div>

      <div className="table_container report_table">
        <Table
          ref={refAddTable}
          maxBodyHeight={addList.limit * 80}
          isLoading={addList.isLoading}
          grouping={addList.grouping}
          limit={addList.limit}
          page={addList.page}
          total={addList.total}
          data={addList.data}
          onPageChange={(page) => {
            setParamReport({
              ...paramReport,
              currentPage: page,
            });
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                return row.tableNum;
              },
              width: "80px",
              align: "center",
            },
            {
              title: "Date",
              render: (row) => {
                if (row.reportDate == null || row.reportDate == "") {
                  return "-";
                }
                // Extracting only the date part
                const date = new Date(row.reportDate);
                const formattedDate = date.toLocaleDateString("en-US");
                return formattedDate;
              },
              width: "100px",
            },
            {
              title: "Time",
              render: (row) => {
                if (row.reportTime == null || row.reportTime == "") {
                  return "-";
                }
                const time = new Date(row.reportTime);
                const formattedTime = time.toLocaleTimeString("en-US", { hour12: true });
                return formattedTime;
              },
              width: "120px",
            },
            {
              title: "User ID",
              render: (row) => {
                if (row.memberCode == null || row.memberCode == "") {
                  return "-";
                }
                return row.memberCode;
              },
              width: "100px",
            },
            {
              title: "Name",
              render: (row) => {
                if (row.name == null || row.name == "") {
                  return "Unknown";
                }
                return row.name;
              },
              width: "100px",
            },
            {
              title: "Use Type",
              render: (row) => {
                if (row.reportType == null || row.reportType == "") {
                  return "unknown";
                }
                return row.reportType;
              },
              width: "150px",
            },
            {
              title: "Created By",
              render: row => row.createdBy ?? "-",
              width: "150px",
            },
            {
              title: "Deposit",
              render: (row) => {
                if (row.addPoint == null || row.addPoint == "") {
                  return "-";
                }
                return row.addPoint;
              },
              width: "150px",
            },
            {
              title: "Expired Point",
              render: (row) => {
                if (row.expiredPoint == null || row.expiredPoint == "") {
                  return "-";
                }
                return row.expiredPoint;
              },
              width: "150px",
            },
            {
              title: "Usage Point",
              render: (row) => {
                if (row.point == null || row.point == "") {
                  return "-";
                }
                return row.point;
              },
              width: "150px",
            },
            {
              title: "Available Point",
              render: row => row.currentPoint ?? "-",
              width: "150px",
            },
          ]}
        />
      </div>
    </>
  );
};

export default AddPoint;
